// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserTests_wrapper__e9HGX"};